import '../styles/footer.scss';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="x5-footer">
      <div className="x5-footer__inner">
        <a href="https://safetynet.xiltrixusa.com/">Contact SafetyNet</a>
        <a href="https://xiltrix.atlassian.net/servicedesk/customer/portal/10">Submit Feedback</a>
        <span className="x5-footer__legal">&copy; {year} XiltriX All Rights Reserved</span>
      </div>
    </footer>
  );
}
